import { render, staticRenderFns } from "./ProductInStock.vue?vue&type=template&id=64a60e19&scoped=true&"
import script from "./ProductInStock.vue?vue&type=script&lang=js&"
export * from "./ProductInStock.vue?vue&type=script&lang=js&"
import style0 from "./ProductInStock.vue?vue&type=style&index=0&id=64a60e19&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a60e19",
  null
  
)

export default component.exports